module.exports = __webpack_public_path__ + "static/media/3.736eada8.svg";